import { useAppDispatch } from "../../../../redux-store";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { loadShareFromOrgName } from "../../../../ducks/app/cargo-dialog";

const SharedFromOrg = ({
  clientId,
  cargoId,
}: {
  clientId: string | undefined;
  cargoId: string;
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["shipmentModal"]);
  const [orgName, setOrgName] = useState<string | null>(null);

  useEffect(() => {
    if (cargoId || !clientId) {
      dispatch(loadShareFromOrgName(cargoId))
        .unwrap()
        .then((v) => {
          setOrgName(v.contractorOrgName);
        })
        .catch(() => {
          // The loadShareFromOrgName thunk has already reported it and shown the error toast.
        });
    }
  }, [clientId, cargoId, dispatch]);

  if (clientId || !cargoId || !orgName) {
    return null;
  }

  return <div className="text-gray-500">{t("sharedBy", { orgName })}</div>;
};

export default SharedFromOrg;
